import { DEFAULT_API_CONFIG } from './apiConfig';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/FormHeaders`;
const formsRoute = `${url}/Forms`;

export const getFormHeaders = async () => {
  const url = `${baseRoute}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getFormHeaderConfig = async () => {
  const response = await fetch(`${formsRoute}/form-header-config`, {
    method: 'GET',
    headers: getHeaders(),
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const updateFormHeaderConfig = async (formHeaderId, canEditOnCancel) => {
  const response = await fetch(`${formsRoute}/${formHeaderId}/form-header-config`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify({ canEditOnCancel }),
  });
  return response.ok ? await response.json() : Promise.reject(response);
};
